/* eslint-disable no-console */
import axios from "axios";
import { acquireToken } from "../auth/authUtils";

const baseUrl = process.env.REACT_APP_BASE_URL;

export const getConfigs = async (region) => {
  try {
    const accessToken = await acquireToken();
    const response = await axios.get(`${baseUrl}/configs/${region}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Get configs API call failed:", error);
    throw error;
  }
};

export const getSignedUrl = async (configId, filename) => {
  try {
    const accessToken = await acquireToken();
    const response = await axios.post(
      `${baseUrl}/upload-url`,
      { configId, filename },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Get signed URL API call failed:", error);
    throw error;
  }
};

export const trackUpload = async (configId, filename, s3Key) => {
  try {
    const accessToken = await acquireToken();
    const response = await axios.post(
      `${baseUrl}/track-upload`,
      { configId, filename, s3Key },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Track upload API call failed:", error);
    throw error;
  }
};

export const getUploads = async (configId) => {
  try {
    const accessToken = await acquireToken();
    const response = await axios.get(`${baseUrl}/config/${configId}/uploads`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Get uploads API call failed:", error);
    throw error;
  }
};
